module.exports = __webpack_public_path__ + "img/pdf-icon.506f08c0.svg";